'use client';

export { PromoCode } from './ui/promo-code';
